import { render, staticRenderFns } from "./onAndoffGame.vue?vue&type=template&id=29ee2257&scoped=true"
import script from "./onAndoffGame.vue?vue&type=script&lang=js"
export * from "./onAndoffGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ee2257",
  null
  
)

export default component.exports